import axios from '../../../build/http-requests/axios-common'

export default {
  state: {
    operatorToEditId: null
  },

  mutations: {
    OPERATOR_TO_EDIT_SELECTED (state, operatorId) {
      state.operatorToEditId = operatorId
    },
    CLEAN_OPERATOR_TO_EDIT (state) {
      state.operatorToEditId = null
      state.clientName = null
    }
  },

  actions: {
    getOperators: ({ commit }, url) => {
      return new Promise((resolve, reject) => {
        axios.get(url).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    getOperatorsWithTaskPermission: ({ commit }) => {
      return axios.get('/operator/byFunctionality', { params: { functionalityId: 209 } })
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error))
    },

    newOperator: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        axios.post('/operator/', data).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    setOperatorToEdit: ({ commit }, operatorId) => {
      return new Promise((resolve, reject) => {
        commit('OPERATOR_TO_EDIT_SELECTED', operatorId)
        resolve()
      })
    },

    cleanOperatorToEdit: ({ commit }) => {
      return new Promise((resolve, reject) => {
        commit('CLEAN_OPERATOR_TO_EDIT')
        resolve()
      })
    },

    getOperator: ({ commit }, operatorId) => {
      return new Promise((resolve, reject) => {
        axios.get('/operator/find', { params: { operatorId: operatorId } }).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    }
  },

  getters: {
    operatorToEditId: state => state.operatorToEditId
  }
}



// WEBPACK FOOTER //
// ./client/store/modules/operator.js